import { graphql } from "@/gql";

export const resolveRelocationLineEmailMutation = graphql(`
  mutation ResolveRelocationLineEmail($id: ID!) {
    resolveRelocationLineEmail(id: $id) {
      id
      status
    }
  }
`);
